import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@my-env/environment';
import { Observable, catchError, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CommonApiService {
  constructor(private httpClient: HttpClient) {}

  private handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Client-side error: ${error.error.message}`;
    } else {
      errorMessage = `Server-side error: ${error.status} ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(() => new Error(errorMessage));
  }

  GET(url: string) {
    return this.httpClient
      .get(`${environment.crossDomainAPI + url}`)
      .pipe(catchError(this.handleError));
  }

  POST(url: string, formData: object) {
    return this.httpClient
      .post(`${environment.crossDomainAPI}${url}`, formData)
      .pipe(catchError(this.handleError));
  }
  PUT(url: string, formData: object) {
    return this.httpClient
      .put(`${environment.crossDomainAPI}${url}`, formData)
      .pipe(catchError(this.handleError));
  }
}
